export const INSURANCE_DETAILS_REQUEST = 'INSURANCE_DETAILS_REQUEST';
export const ONBOARDING_DETAILS_SUCCESS = 'ONBOARDING_DETAILS_SUCCESS';
export const UPDATE_ONBOARDING = 'UPDATE_ONBOARDING';
export const UPDATE_ONBOARDING_SUCCESS = 'UPDATE_ONBOARDING_SUCCESS';
export const SAVE_ONBOARDING = 'SAVE_ONBOARDING';
export const SAVE_INSURANCE_CONFIG = 'SAVE_INSURANCE_CONFIG';
export const CLEAR_ONBOARDING = 'CLEAR_ONBOARDING';
export const CLEAR_ONBOARDING_SUCCESS = 'CLEAR_ONBOARDING_SUCCESS';
export const FETCH_ONBOARDING = 'FETCH_ONBOARDING';
export const FETCH_ONBOARDING_SUCCESS = 'FETCH_ONBOARDING_SUCCESS';
export const UPDATE_WHATSAPP_PAID_PROMO_SHOWN = 'UPDATE_WHATSAPP_PAID_PROMO_SHOWN';
export const UPDATE_INSURANCE_STORAGE = 'UPDATE_INSURANCE_STORAGE';
